import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { useEffect } from 'react';
import { clearQueries } from '../lib/Queries';

const ErrorPage = ({ isPublic, eventId }) => {
    // This is only set when rendered as a router errorElement, not as a
    //  Sentry.ErrorBoundary fallback (those pass an eventId instead)
    const error = useRouteError();
    if (error) {
        console.error(error);
    }

    useEffect(() => {
        // Clear out query cache in case it's bad data
        clearQueries();
    }, []);

    let message = '';
    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            message = 'Page not found';
        }
    }

    return (
        <div className="min-h-screen w-full bg-gray-100 flex items-center justify-center">
            <div className="p-6 panel">
                <h2>{message || 'Error!'}</h2>
                <p className="mt-2">
                    Please check the URL or refresh the page to try again.
                    {!isPublic && (
                        <>
                            <br />
                            If this problem continues please{' '}
                            <a href="https://hello.breely.com/form/7011">contact support</a>.
                        </>
                    )}

                </p>

                <button
                    type="button"
                    className="btn-pill mt-4"
                    onClick={() => window.location.reload()}
                >
                    Reload Page
                </button>

                {!!eventId && (
                    <div className="text-gray-500 text-sm mt-4">
                        Please include this reference when contacting support:
                        <br />
                        <span className="select-all font-mono">{eventId}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ErrorPage;
